import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

const Grouped = ({ color = 'icon.primary', fill = 'transparent', ...props }) => (
  <IconBase viewBox='0 0 18 18' {...props}>
    <Path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 17C4.58133 17 1 13.4187 1 9C1 4.58133 4.58133 1 9 1C13.4187 1 17 4.58133 17 9C17 13.4187 13.4187 17 9 17Z'
      stroke={color}
      fill='transparent'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M7.53256 9.6823C8.31208 10.4618 8.31208 11.7257 7.53256 12.5052C6.75303
         13.2847 5.48917 13.2847 4.70965 12.5052C3.93012 11.7257 3.93012 10.4618
          4.70965 9.6823C5.48917 8.90277 6.75303 8.90277 7.53256 9.6823'
      stroke={color}
      fill={fill}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M13.0247 9.6823C13.8043 10.4618 13.8043 11.7257 13.0247 12.5052C12.2452
         13.2847 10.9814 13.2847 10.2018 12.5052C9.42231 11.7257 9.42231 10.4618
          10.2018 9.6823C10.9814 8.90277 12.2452 8.90277 13.0247 9.6823'
      stroke={color}
      fill={fill}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M10.2747 4.70574C11.0543 5.48527 11.0543 6.74913 10.2747 7.52865C9.49522
         8.30818 8.23136 8.30818 7.45183 7.52865C6.67231 6.74912 6.67231 5.48526
          7.45183 4.70574C8.23136 3.92621 9.49522 3.92621 10.2747 4.70574'
      stroke={color}
      fill={fill}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </IconBase>
)

Grouped.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Grouped
